import type { SVGProps } from "react";

/**
 * Stir / mix — wooden spoon swirling in a pot.
 */
export function StirIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Pot */}
      <rect
        x={8}
        y={26}
        width={32}
        height={16}
        rx={3}
        fill="currentColor"
        opacity={0.15}
      />
      <rect
        x={6}
        y={24}
        width={36}
        height={4}
        rx={2}
        fill="currentColor"
        opacity={0.3}
      />
      {/* Handle */}
      <rect
        x={10}
        y={38}
        width={4}
        height={6}
        rx={1}
        fill="currentColor"
        opacity={0.5}
      />
      <rect
        x={34}
        y={38}
        width={4}
        height={6}
        rx={1}
        fill="currentColor"
        opacity={0.5}
      />
      {/* Spoon shaft */}
      <rect
        x={22}
        y={4}
        width={4}
        height={22}
        rx={1.5}
        fill="currentColor"
        opacity={0.7}
      />
      {/* Spoon head (oval) */}
      <ellipse
        cx={24}
        cy={28}
        rx={6}
        ry={4}
        fill="currentColor"
        opacity={0.5}
      />
      {/* Swirl lines */}
      <path
        d="M16 30c4-2 8 0 12-2"
        stroke="currentColor"
        strokeWidth={1}
        opacity={0.4}
        fill="none"
      />
      <path
        d="M18 34c4-2 8 0 12-2"
        stroke="currentColor"
        strokeWidth={1}
        opacity={0.3}
        fill="none"
      />
    </svg>
  );
}
